import { ApiKy } from './index'
import { FeatureFlag, UpdateFeatureFlagPayload } from '~/types/feature-flags'

export default class Api extends ApiKy {
  getAll(): Promise<FeatureFlag[]> {
    return this.ky.get(this.url).json<FeatureFlag[]>()
  }

  update(featureFlagId: string, payload: UpdateFeatureFlagPayload) {
    return this.ky
      .patch(`${this.url}/${featureFlagId}`, { json: payload })
      .json<FeatureFlag>()
  }
}
